import React from 'react';
import { Box, Button, Card, FlexBox, Icon, Typography, tokensRaw } from '@vp/swan';
import { LayeredAvatars } from '@99designs/design-services-common';
import { __, __vistaRoute } from '@99designs/i18n';
import { NEW_PROJECT_ROUTE } from '../utils/constants';

interface PreferredDesignerCTAProps {
    avatarUrls?: ReadonlyArray<string | null | undefined>;
}

export const PreferredDesignerCTA: React.FC<PreferredDesignerCTAProps> = ({ avatarUrls = [] }) => {
    const href = `${__vistaRoute(NEW_PROJECT_ROUTE)}?preferredDesigner=true`;

    return (
        <Card
            bordered
            style={{
                backgroundColor: tokensRaw.SwanSemColorBgStrong,
            }}
        >
            <FlexBox flexDirection="column" gap="between-actions">
                <FlexBox alignItems="center" gap="between-actions" mb={2}>
                    <LayeredAvatars avatarUrls={avatarUrls} size={32} max={3} />
                    <Typography fontSkin="body-standard-bold">
                        {__('Work with your designers again')}
                    </Typography>
                </FlexBox>
                <Typography fontSkin="body-standard" mb={2}>
                    {__(
                        "We'll do our best to match your project with your preferred designer. Otherwise, we'll pair you with another expert who'll fit your creative needs."
                    )}
                </Typography>
                <Box>
                    <Button
                        skin="primary"
                        iconPosition="right"
                        render={({ children, ...props }) => (
                            <a {...props} href={href}>
                                {children}
                                <Icon iconType="arrowRight" />
                            </a>
                        )}
                    >
                        {__('Start a project with a preferred designer')}
                    </Button>
                </Box>
            </FlexBox>
        </Card>
    );
};
